import { Card, CardBody, Switch } from '@heroui/react'
import { Controller, useFormContext } from 'react-hook-form'

export function EnableDisableSection({ direction, isDisabled }) {
  const { control } = useFormContext()
  const title = direction === 'inbound' ? 'Inbound Calls' : 'Outbound Calls'
  const description = direction === 'inbound'
    ? 'Enable inbound calls for this phone number.'
    : 'Enable outbound calls for this phone number.'

  return (
    <Card shadow="sm" radius="none" className="px-4 py-2">
      <CardBody>
        <div className="flex items-center justify-between">
          <div className="flex flex-col gap-0.5">
            <h3 className="text-lg font-medium">{title}</h3>
            <p className="text-sm text-gray-500">{description}</p>
          </div>
          <Controller
            name={`${direction}.enabled`}
            control={control}
            render={({ field }) => (
              <Switch
                isSelected={field.value}
                onValueChange={field.onChange}
                isDisabled={isDisabled}
              />
            )}
          />
        </div>
      </CardBody>
    </Card>
  )
}
